import React from "react";
import { TextField, TextareaAutosize, TextFieldProps } from "@mui/material";

// Define a new type by extending TextFieldProps with custom properties
type CustomTextFieldProps = TextFieldProps & {
  backgroundd?: string; // Optional prop for background color
};

const CustomTextField: React.FC<CustomTextFieldProps> = ({
  backgroundd,
  ...props
}) => {
  return (
    <TextField
      {...props}
      variant="outlined"
      style={{
        fontSize: "10px",
        border: "1px solid #C4C4C4",
        borderRadius: "10px",
        padding: "0px 8px",
        background: backgroundd || "#FFF", // Use provided color or default to #FFF
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            border: "none", // Remove default borders
          },
        },
        input: {
          color: "#333333", // Placeholder color
          fontSize: "14px",
        },
        "& .MuiFormHelperText-root": {
          fontSize: "16px",
        },
      }}
    />
  );
};

export const CustomTextarea: React.FC<{
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  backgroundd?: string; // Optional prop for background color
  maxLength?: number; // Optional prop for maximum characters
}> = ({ value, onChange, placeholder, backgroundd, maxLength }) => {
  return (
    <div style={{ position: "relative" }}>
      <TextareaAutosize
        value={value}
        onChange={(e) => {
          if (maxLength && e.target.value.length > maxLength) return;
          onChange(e);
        }}
        placeholder={placeholder}
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: "10px",
          border: "1px solid #C4C4C4",
          fontSize: "16px",
          background: backgroundd || "#FFF", // Use provided color or default to #FFF
          color: "#333333",
          height: "200px",
          resize: "none",
        }}
      />
      {maxLength && (
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            right: "10px",
            fontSize: "12px",
            color: "#979797",
          }}
        >
          {value.length}/{maxLength}
        </div>
      )}
    </div>
  );
};

export default CustomTextField;